import { render, staticRenderFns } from "./VirtualServerAddOns.vue?vue&type=template&id=3be23539&"
import script from "./VirtualServerAddOns.vue?vue&type=script&lang=js&"
export * from "./VirtualServerAddOns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports